import dayjs from "dayjs"
import { createContext, useContext, useState } from "react"

interface IDateRangeFilterProviderContext {
    start:dayjs.Dayjs
    end:dayjs.Dayjs
    setStart:(date:dayjs.Dayjs)=>void
    setEnd:(date:dayjs.Dayjs)=>void
}
const DateRangeFilterProviderContext = createContext<IDateRangeFilterProviderContext>({} as any)
const useDateRangeFilter = () => useContext(DateRangeFilterProviderContext)

export default useDateRangeFilter

export function DateRangeFilterProvider(props:{children:any}) {
    const [start,setStart] = useState<dayjs.Dayjs>(dayjs(new Date(2000, 0, 1)))
    const [end,setEnd] = useState<dayjs.Dayjs>(dayjs(new Date(Date.now() + 24*3600*1000)))
    return <DateRangeFilterProviderContext.Provider value={{start,end,setStart,setEnd}}>{props.children}</DateRangeFilterProviderContext.Provider>
}